import { Tabs } from '@dreamtree-org/twreact-ui';

/**
 * A queue/status tab strip (no panels): the selected key drives a query.
 * tabs: [{ key, label, count? }]. Scrolls horizontally on phones.
 */
export default function StatusTabs({ tabs, value, onChange }) {
  const index = Math.max(0, tabs.findIndex((t) => t.key === value));
  return (
    <div className="overflow-x-auto -mx-1 px-1">
      <Tabs index={index} onChange={(i) => onChange(tabs[i].key)} variant="line" orientation="horizontal">
        <Tabs.List className="min-w-max border-b border-[var(--app-border)]">
          {tabs.map((t) => (
            <Tabs.Tab key={t.key} tabClassName="min-h-[44px] whitespace-nowrap">
              {t.label}
              {t.count != null ? <span className="ml-1 text-xs opacity-60">({t.count})</span> : null}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
    </div>
  );
}
